import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { withFormik, FormikProps } from 'formik';
import { Grid, Box, CircularProgress } from '@material-ui/core';
import { translate } from 'helpers/intl';
import validationSchema from 'components/ChangePassewordModal/validationSchema';
import messages from 'components/ChangePassewordModal/messages';
import { OrangeButton } from 'components/Button';
import { ColoredDivider, StyledGrid } from 'components/MenuItem/styles';
import PasswordInputField from 'components/InputField/Password';
import PasswordProgressBar from 'components/PasswordProgressBar';
import { ShortBody } from 'components/Typography';
import { StyledForm } from 'components/ChangePassewordModal/styles';
import get from 'lodash/get';

const ChangePasswordForm = (
  props: {
    handleClose: Function;
    isLoading: boolean;
  } & FormikProps<FormValues>,
) => {
  const {
    values,
    touched,
    errors,
    handleSubmit,
    handleChange,
    handleBlur,
  } = props;
  return (
    <StyledForm onSubmit={handleSubmit}>
      <Box paddingX={2} pb={2}>
        <Grid container justify="center">
          <Grid item xs={12}>
            <Box mb={3}>
              <ShortBody weight="400">
                {translate(get(messages, 'currentPasswordTitle'), props)}
              </ShortBody>
              <PasswordInputField
                label={translate(get(messages, 'currentPassword'), props)}
                name="currentPassword"
                placeholder={translate(get(messages, 'currentPassword'), props)}
                value={values.currentPassword}
                error={errors.currentPassword && touched.currentPassword}
                helperText={touched.currentPassword && errors.currentPassword}
                handleChange={handleChange}
                handleBlur={handleBlur}
              />
            </Box>
          </Grid>

          <Grid item xs={12}>
            <ShortBody weight="400">
              {translate(get(messages, 'newPasswordTitle'), props)}
            </ShortBody>
            <PasswordInputField
              label={translate(get(messages, 'newPassword'), props)}
              name="newPassword"
              placeholder={translate(get(messages, 'newPassword'), props)}
              value={values.newPassword}
              error={errors.newPassword && touched.newPassword}
              helperText={
                touched.newPassword && errors.newPassword
                  ? errors.newPassword
                  : translate(get(messages, 'passwordMsg'), props)
              }
              handleChange={handleChange}
              handleBlur={handleBlur}
            />
            <Box mb={2} mt={0.6}>
              <PasswordProgressBar value={values.newPassword} />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <PasswordInputField
              label={translate(get(messages, 'confirmPassword'), props)}
              name="confirmPassword"
              placeholder={translate(get(messages, 'confirmPassword'), props)}
              value={values.confirmPassword}
              error={errors.confirmPassword && touched.confirmPassword}
              helperText={touched.confirmPassword && errors.confirmPassword}
              handleChange={handleChange}
              handleBlur={handleBlur}
            />
          </Grid>
        </Grid>
      </Box>
      <ColoredDivider orientation="horizontal" />
      <StyledGrid spacing={5} container justify="flex-end">
        <Grid item>
          <OrangeButton onClick={props.handleClose}>
            {translate(get(messages, 'cancel'), props)}
          </OrangeButton>
        </Grid>
        <Grid item>
          <OrangeButton
            type="submit"
            variant="contained"
            disabled={props.isLoading}
          >
            {translate(get(messages, 'valid'), props)}
            {props.isLoading ? (
              <CircularProgress
                color="inherit"
                size={20}
                style={{ marginLeft: '5px' }}
              />
            ) : null}
          </OrangeButton>
        </Grid>
      </StyledGrid>
    </StyledForm>
  );
};

export interface FormProps {
  intl: IntlShape;
  changePassword: Function;
  handleClose: Function;
  isLoading: boolean;
}

interface FormValues {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

const Form = withFormik<FormProps, FormValues>({
  mapPropsToValues: () => {
    return {
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
    };
  },
  validationSchema,
  handleSubmit: (values, { props }) => {
    props.changePassword(values);
    return props.handleClose();
  },
})(ChangePasswordForm);

export default injectIntl(Form);
